export default __webpack_public_path__ + "static/android-icon-192x192-66d07cc8867fcc5da143c1c62cf8626e.png";